import React, { useEffect, useState } from "react";
import { Share, X, Smartphone } from "lucide-react";

const DISMISS_KEY = "flexline_ios_install_dismissed";

// Slim, dismissible banner shown to iPhone/iPad Safari visitors (not yet installed)
// prompting Add-to-Home-Screen — which is what unlocks push alerts + a native feel.
export const IosInstallBanner = () => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent) ||
            (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
        const isStandalone = (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) ||
            window.navigator.standalone === true;
        const dismissed = localStorage.getItem(DISMISS_KEY) === "1";
        if (isIOS && !isStandalone && !dismissed) setShow(true);
    }, []);

    if (!show) return null;

    const dismiss = () => {
        localStorage.setItem(DISMISS_KEY, "1");
        setShow(false);
    };

    return (
        <div
            className="md:hidden fixed bottom-0 inset-x-0 z-[60] bg-espresso text-[#FAF5FF] px-4 py-3 flex items-start gap-3 shadow-[0_-4px_16px_rgba(0,0,0,0.25)]"
            data-testid="ios-install-banner"
        >
            <Smartphone className="w-5 h-5 mt-0.5 shrink-0 text-accent-blue" />
            <div className="flex-1 text-sm leading-snug">
                <span className="font-semibold">Install FlexLine</span> — tap{" "}
                <Share className="inline w-4 h-4 mx-0.5 align-text-bottom" /> <span className="font-semibold">Share</span>, then{" "}
                <span className="font-semibold">"Add to Home Screen"</span> to enable call alerts &amp; open faster.
            </div>
            <button
                onClick={dismiss}
                className="p-1 -mr-1 text-[#FAF5FF]/70 hover:text-white shrink-0"
                aria-label="Dismiss"
                data-testid="ios-install-banner-dismiss"
            >
                <X className="w-4 h-4" />
            </button>
        </div>
    );
};
